import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ActionablePlaceholder } from 'ui-components/components/display-grid/actionable-placeholder';

import { messages } from './messages';

export const TransferOrdersGridPlaceholder = () => {
  return (
    <ActionablePlaceholder
      description={<FormattedMessage {...messages.gridPlaceholderDescription} />}
      title={
        <FormattedMessage
          {...messages.gridPlaceholderTitle}
          values={{
            b: (chunks) => <b>{chunks}</b>,
          }}
        />
      }
    />
  );
};
